import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  FaTachometerAlt, 
  FaHotel, 
  FaCalendarAlt, 
  FaTags, 
  FaChartBar, 
  FaUsers, 
  FaCreditCard,
  FaBars,
  FaUser,
  FaSignOutAlt,
  FaPercentage,
  FaUniversalAccess,
  FaHandshake,
  FaConciergeBell
} from 'react-icons/fa';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    logout(navigate);
  };

  const menuItems = [
    { path: '/', label: 'Dashboard', icon: <FaTachometerAlt /> },
    { path: '/hotels', label: 'Hotels', icon: <FaHotel /> },
    { path: '/bookings', label: 'Bookings', icon: <FaCalendarAlt /> },
    // Only show Commission to super admins
    ...(user?.role === 'super_admin' ? [
      { path: '/hotels/commission', label: 'Commission', icon: <FaPercentage /> }
    ] : []),
    { path: '/coupons', label: 'Coupons', icon: <FaTags /> },
    // Reports hidden temporarily
    // { path: '/reports', label: 'Reports', icon: <FaChartBar /> },
    // Only show these items to super admins
    ...(user?.role === 'super_admin' ? [
      { path: '/users', label: 'Users', icon: <FaUsers /> },
      // Transactions hidden temporarily
      // { path: '/transactions', label: 'Transactions', icon: <FaCreditCard /> },
      { path: '/accessibility', label: 'Accessibility', icon: <FaUniversalAccess /> },
      { path: '/amenities', label: 'Amenities', icon: <FaConciergeBell /> },
      { path: '/partners', label: 'Partners', icon: <FaHandshake /> },
      { path: '/testimonials', label: 'Testimonials', icon: <FaUser /> }
    ] : [])
  ];

  // Function to render menu items with sub-items
  const renderMenuItems = (items) => {
    return items.map((item) => (
      <li key={item.path}>
        <Link 
          to={item.path} 
          className={`${location.pathname === item.path ? 'active' : ''}`}
        >
          <span className="menu-icon">{item.icon}</span>
          {sidebarOpen && <span className="menu-text">{item.label}</span>}
        </Link>
      </li>
    ));
  };

  return (
    <div className={`dashboard-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>Inclugo</h2>
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {sidebarOpen ? '←' : '→'}
          </button>
        </div>
        <nav className="sidebar-nav">
          <ul>
            {renderMenuItems(menuItems)}
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="top-bar">
          <div className="top-bar-left">
            <button className="menu-toggle" onClick={toggleSidebar}>
              <FaBars />
            </button>
            <h1>Inclugo Dashboard</h1>
          </div>
          <div className="top-bar-right">
            <div className="user-info">
              <span>{user?.name}</span>
              <div className="user-avatar">
                <FaUser />
              </div>
              <button className="logout-btn" onClick={handleLogout}>
                <FaSignOutAlt />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;